import * as React from 'react'

interface IComponentProps {
  baseNavigateUrl?: string
  idValue?: string
  list: any
  noLink?: boolean
}

export default class PillListRenderer extends React.PureComponent<IComponentProps> {
  public render() {
    const id = this.props.idValue || 'id'

    const contacts = this.props.list.map((item: any) => {
      return (
        <span
          key={item[id]}
          className='mx-1 badge badge-pill badge-secondary justify-items-center'
        >
          {this.props.noLink === true ? (
            <span className='text-primary'>{item.name}</span>
          ) : (
            <a
              href={
                this.props.baseNavigateUrl
                  ? `${this.props.baseNavigateUrl}/${item[id]}`
                  : '#'
              }
              target='_blank'
              rel='noreferrer'
            >
              {item.name}
            </a>
          )}
        </span>
      )
    })

    return contacts
  }
}
